import { useState } from "react";
import useHttp from "./use_http";
import { CurrenciesEnum } from "../utils/enums";

const useDashboard = () => {
  const { httpService } = useHttp();

  const [getDashboardOverviewLoading, setGetDashboardOverviewLoading] =
    useState(false);
  const [getSaleChartLoading, setGetSaleChartLoading] = useState(false);
  const [getIncomeChartLoading, setGetIncomeChartLoading] = useState(false);
  const [getEnrollmentsChartLoading, setGetEnrollmentsChartLoading] =
    useState(false);
  const [getLastReviewsLoading, setGetLastReviewsLoading] = useState(false);
  const [getMembersLoading, setGetMembersLoading] = useState(false);

  const [paginates, setPaginates] = useState({
    current: 1,
    total: 1,
  });

  const [overviewData, setOverviewData] = useState(null);
  const [saleChartData, setSaleChartData] = useState(null);
  const [incomeChartData, setIncomeChartData] = useState(null);
  const [enrollmentsData, setEnrollmentsData] = useState(null);
  const [lastReviewsData, setLastReviewsData] = useState(null);
  const [membersData, setMembersData] = useState([]);

  const getDashboardOverview = async () => {
    try {
      setGetDashboardOverviewLoading(true);
      const response = await httpService.get(`instructor/dashboard/overview`);
      setGetDashboardOverviewLoading(false);
      setOverviewData(response.data);
    } catch ({ err, response }) {
      setGetDashboardOverviewLoading(false);
    }
  };

  const getSaleChart = async () => {
    try {
      setGetSaleChartLoading(true);
      const response = await httpService.get(`instructor/dashboard/chart/sale`);
      setGetSaleChartLoading(false);
      if (response.data?.length > 0) {
        setSaleChartData(response.data);
      } else {
        setSaleChartData([]);
      }
    } catch ({ err, response }) {
      setGetSaleChartLoading(false);
    }
  };

  const getIncomeChart = async () => {
    try {
      setGetIncomeChartLoading(true);
      const response = await httpService.get(
        `instructor/dashboard/chart/income`
      );
      setGetIncomeChartLoading(false);
      if (response.data?.length > 0) {
        const months = [...new Set(response.data.map((d) => d.month))].sort();

        const grouped = {};
        for (const { month, currency, totalEarnings } of response.data) {
          if (!grouped[currency]) {
            grouped[currency] = Array(months.length).fill(0);
          }
          const idx = months.indexOf(month);
          grouped[currency][idx] = totalEarnings;
        }

        const seriesIncome = Object.entries(grouped).map(
          ([currencyId, earnings]) => {
            const label =
              CurrenciesEnum.find((c) => c.value === Number(currencyId))
                ?.label || currencyId;
            return { name: label, data: earnings };
          }
        );
        setIncomeChartData({
          labels: months,
          series: seriesIncome,
        });
      } else {
        setIncomeChartData([]);
      }
    } catch ({ err, response }) {
      setGetIncomeChartLoading(false);
    }
  };

  const getEnrollmentsChart = async () => {
    try {
      setGetEnrollmentsChartLoading(true);
      const response = await httpService.get(`instructor/dashboard/members`);
      setGetEnrollmentsChartLoading(false);
      if (response.data.data) {
        setEnrollmentsData(response.data.data);
      }
    } catch ({ err, response }) {
      setGetEnrollmentsChartLoading(false);
    }
  };

  const getLastReviews = async () => {
    try {
      setGetLastReviewsLoading(true);
      const response = await httpService.get(`instructor/dashboard/review`);
      setGetLastReviewsLoading(false);
      if (response.data.data) {
        setLastReviewsData(response.data.data);
      }
    } catch ({ err, response }) {
      setGetLastReviewsLoading(false);
    }
  };

  const getMembers = async (page) => {
    let paramsData = {
      page: page,
      limit: 10,
    };
    try {
      setGetMembersLoading(true);
      const response = await httpService.get("instructor/dashboard/members", {
        params: paramsData,
      });
      setGetMembersLoading(false);
      setPaginates({
        current: response.data.page,
        total: response.data.pageCount,
      });
      setMembersData(response.data.data);
    } catch ({ err, response }) {
      setGetMembersLoading(false);
    }
  };

  const exports = {
    // entity methods
    getDashboardOverview,
    getSaleChart,
    getIncomeChart,
    getEnrollmentsChart,
    getLastReviews,
    getMembers,
    // entity states
    overviewData,
    saleChartData,
    incomeChartData,
    enrollmentsData,
    lastReviewsData,
    membersData,
    // controller states
    paginates,
    // loading states
    getDashboardOverviewLoading,
    getSaleChartLoading,
    getIncomeChartLoading,
    getEnrollmentsChartLoading,
    getLastReviewsLoading,
    getMembersLoading,
  };
  return exports;
};

export default useDashboard;
